module.exports = __webpack_public_path__ + "img/service3-2.aa903715.jpg";